import { useMemo } from "react";
import { Event } from "src/lib/slices/alcoholSlice";
import EventCounter from "./EventCounter";

export default function EventCounters({ events }: { events: Event[] }) {
  const eventCounters = useMemo(() => {
    const eventCounters: Record<string, number> = {};

    events.forEach((event) => {
      if (event.type === "custom") return;

      if (eventCounters[event.type]) {
        eventCounters[event.type]++;
      } else {
        eventCounters[event.type] = 1;
      }
    });

    return eventCounters;
  }, [events]);

  return (
    <>
      {Object.keys(eventCounters).map((eventType) => (
        <EventCounter
          key={eventType}
          type={eventType}
          count={eventCounters[eventType]}
        />
      ))}
    </>
  );
}
